<template>
    <q-page class="flex flex-center">
        <div class="q-pa-md full-width">
            <div class="fit row no-wrap-lg no-wrap-xl content-center justify-center q-gutter-lg q-pa-sm-sm q-pa-xs-xs
            q-pa-md-md q-pa-lg-lg q-pa-xl-xl">
                <q-card class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 service-card">
                    <q-img :src="require('@/assets/shutterstock_587205803.jpg')" :ratio="16/9"/>
                    <q-card-section class="bg-secondary text-center">
                        <div class="text-h6">Infrastructure Automation</div>
                    </q-card-section>
                    <q-card-section class="q-ma-md Page-Text-Small text-justify">
                        <p>
                            The definition van automation by Wikipedia: Automation is the technology by which a process
                            or procedure is performed with minimal human assistance.
                        </p>
                        <p>
                            By automating the delivery of software we speed up the process and we
                            eliminate errors. This process will free up the time of Developers and Operations Team to do
                            other work. This is accomplished by implementing Continuous Integration and Continuous Deliver Pipelines.
                        </p>
                    </q-card-section>
                    <q-separator />
                    <q-card-section>
                        <div class="text-h6"><strong>Benefits of our services:</strong></div>
                        <q-list>
                            <q-item>
                                <q-item-section avatar>
                                    <q-icon name="double_arrow"/>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="Page-Text-Small">DevOps</q-item-label>
                                    <q-item-label caption lines="3">We do this together with your teams and try to implemente a DevOps way of working</q-item-label>
                                </q-item-section>
                            </q-item>
                            <q-item>
                                <q-item-section avatar>
                                    <q-icon name="double_arrow"/>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="Page-Text-Small">Pipelines</q-item-label>
                                    <q-item-label caption lines="3">We help to design and implement software delivery pipelines</q-item-label>
                                </q-item-section>
                            </q-item>
                            <q-item>
                                <q-item-section avatar>
                                    <q-icon name="double_arrow"/>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="Page-Text-Small">Infrastructure-as-Code</q-item-label>
                                    <q-item-label caption lines="3">We define infrastructue as software code, this way we can use the same principles that you apply for software</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-card-section>
                </q-card>
                <q-card class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 service-card">
                    <q-img :src="require('@/assets/shutterstock_600464906.jpg')"
                           :ratio="16/9"/>
                    <q-card-section class="bg-secondary text-center">
                        <div class="text-h6">Move to Cloud</div>
                    </q-card-section>
                    <q-card-section class="q-ma-md Page-Text-Small text-justify">
                        <p>
                            Moving to the cloud gives the business agility and scalability that is very difficult to
                            achieve in an on premise datacenter. You need to take into account deliveries of hardware
                            vendors, rackspace, cooling, electricity.
                        </p>
                        <p>
                            By moving to the cloud, the cloud provider takes
                            care of these things. Because of the scale, a cloud provider can deliver storage and compute
                            that is secure and compliant, billed by the second.
                        </p>
                    </q-card-section>
                    <q-separator />
                    <q-card-section>
                        <div class="text-h6"><strong>Benefits of our services:</strong></div>
                        <q-list>
                            <q-item>
                                <q-item-section avatar>
                                    <q-icon name="double_arrow"/>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="Page-Text-Small">Landingzone</q-item-label>
                                    <q-item-label caption lines="3">We design and implement a landingzone with all the required elements to deliver applications</q-item-label>
                                </q-item-section>
                            </q-item>
                            <q-item>
                                <q-item-section avatar>
                                    <q-icon name="double_arrow"/>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="Page-Text-Small">Secure</q-item-label>
                                    <q-item-label caption lines="3">Infrastructure automation helps us build secure, auditable infrastructure</q-item-label>
                                </q-item-section>
                            </q-item>
                            <q-item>
                                <q-item-section avatar>
                                    <q-icon name="double_arrow"/>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="Page-Text-Small">Cost Reduction</q-item-label>
                                    <q-item-label caption lines="3">We help you look at ways to cut operating cost.</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-card-section>
                </q-card>
            </div>

        </div>


    </q-page>
</template>

<script>
    export default {
        name: "Services"
    }
</script>

<style scoped>
    .service-card {
        width: 100%;
        max-width: 400px;
    }
</style>